import { useAuth } from '../store/auth';
import { useDeviceStore } from '../store/device';
import { StatusToggle } from '../components/StatusToggle';
import { AudioGate } from '../components/AudioGate';
import { TeamStatusSidebar } from '../components/TeamStatusSidebar';
import { QueuePanel } from '../components/QueuePanel';
import { RecentCallsPanel } from '../components/RecentCallsPanel';
import { DialerPane } from '../components/DialerPane';

export function DashboardPage() {
  const user = useAuth(s => s.user)!;

  const ready = useDeviceStore(s => s.ready);
  const audioUnlocked = useDeviceStore(s => s.audioUnlocked);

  return (
    <>
      <h2 className="text-lg font-semibold text-slate-900">Dashboard</h2>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <div className="lg:col-span-2 space-y-4">
          {!audioUnlocked && <AudioGate>{null}</AudioGate>}
          {audioUnlocked && <StatusToggle />}
          {audioUnlocked && <DialerPane />}

          <div className="bg-white border border-slate-200 rounded-xl p-6">
            <p className="text-sm text-slate-700">
              Hello, <span className="font-medium">{user.email}</span> ({user.role}).
            </p>
            <p className="text-sm text-slate-500 mt-2">
              {ready
                ? 'Twilio Voice connected. Set yourself Available to receive calls on the dispatch line.'
                : 'Connecting to Twilio Voice…'}
            </p>
          </div>

          <RecentCallsPanel />
        </div>

        <aside className="space-y-4">
          <TeamStatusSidebar />
          <QueuePanel />
        </aside>
      </div>
    </>
  );
}
